import Sidemenu from '../components/base/sidemenu';
import User from '../components/user/user';
import SelectUser from '../components/user/Selectuser';
import { useSearchParams } from "react-router-dom";

export default function DashboardPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const tab = searchParams.get("tab") === "selectuser" ? "selectuser" : "alluser";

    const changeTab = (nextTab) => {
        const nextParams = new URLSearchParams(searchParams);
        nextParams.set("tab", nextTab);
        nextParams.set("page", "1");
        setSearchParams(nextParams);
    };
    return (
        <div className='flex'>
            
            <Sidemenu />
            <div className="tabs_wrp user_tabs">
                <button onClick={() => changeTab("alluser")} className={tab === "alluser" ? "active" : ""}>전체 사용자</button>
                <button onClick={() => changeTab("selectuser")} className={tab === "selectuser" ? "active" : ""}>담당 사용자</button>
            </div>
            {/* 사용자 상세정보 */}
            {tab === "alluser" && (<User />)}
            {tab === "selectuser" && (<SelectUser />)}
        </div>
    );
}
